import { CircleMarker } from 'react-leaflet';
import type { ICoordinate } from '../../../../../../../../../models/coordinate.model';
import Colors from '../../../../../../../../../helpers/colors.helper';

function NonPublicTransportEndpointMarker({ coordinate }: { coordinate: ICoordinate }) {
  return <CircleMarker center={[coordinate.latitude, coordinate.longitude]} radius={8} fillColor={Colors.vtdWhite} fillOpacity={1} color={Colors.vtdBlack} weight={4} />;
}

export default NonPublicTransportEndpointMarker;
